<template>
    <div v-if="isLogin && !isLoading" id="allplan">
      <div class="logo-col">
        <a href="/home"><img class="logo" src="../assets/logo_v08-37.png"></a>
      </div>
      <div v-for="item in reportData.holderData" :key="item.id">
          <table class="w-75">
            <tr>
              <th class="w-25">{{ item.holder_name }}</th>
              <th>總配額</th>
              <th>用量</th>
              <th>餘額可分配</th>
            </tr>
            <tr>
              <td>總存量上限</td>
              <td>{{ formatBytes(item.storage_total) }}</td>
              <td>{{ formatBytes(item.storage_used) }}</td>
              <td>{{ formatBytes(item.storage_total - item.storage_used) }}</td>
            </tr>
            <tr>
              <td>年度AI查詢總配額</td>
              <td>{{ item.year_search.toLocaleString() }}</td>
              <td>{{ item.search_used.toLocaleString() }}</td>
              <td>{{ (item.year_search - item.search_used).toLocaleString() }}</td>
            </tr>
          </table>
          <p />
          <div class="sub-account-statistic">
            <p class="company-total"><strong class="account-count">共計客戶數：{{ reportData.companyPlanData.filter(k => k.holder_id == item.id).length }}</strong>
              <button class="button" @click="newCompany(item.id)">新增子帳號</button></p>
          </div>
          <p />
          <table class="w-100">
            <tr>
              <th>子帳號</th>
              <th>服務計劃名</th>
              <th>開帳生效日期</th>
              <th>存量上限</th>
              <th>現時存量</th>
              <th>本月AI查詢次數上限</th>
              <th>本月已查詢次數</th>
              <th>本月餘下查詢次數</th>
              <th>下次重置查詢次數時間</th>
              <th>本年累積查詢次數</th>
              <th>LOG</th>
            </tr>
            <tr v-for="plan in reportData.companyPlanData.filter(k => k.holder_id == item.id)" :key="plan.id">
              <td><a ref="moreLink" href="#" class="more-link" @click="toggleCompanyPopup(plan)">{{ plan.company_name }}</a></td>
              <td>{{ plan.plan_name }}</td>
              <td>{{ plan.storage_plan_starttime.split(' ')[0] }}</td>
              <td>{{ formatBytes(plan.storage_limit) }}</td>
              <td>{{ formatBytes(plan.storage_used) }}</td>
              <td>{{ plan.search_limit.toLocaleString() }}</td>
              <td>{{ plan.search_used.toLocaleString() }}</td>
              <td>{{ (plan.search_limit - plan.search_used).toLocaleString() }}</td>
              <td>{{ plan.reset_time.split(' ')[0] }}</td>
              <td>{{ plan.year_used.toLocaleString() }}</td>
              <td><button class="button" @click="toggleLogDetailPopup(plan)">>查看</button></td>
            </tr>
          </table>
          <p><br /><br /></p>
      </div>
    </div>
    <logDetail v-if="isShowLogDetailPopup" :log_data="logDetailData" :comp_name="logDetailComp" @toggleLogDetailPopup="toggleLogDetailPopup">
    </logDetail>
    <editCompany v-if="isShowCompanyPopup" :comp_plan_data="companyPlanData" :plan_data="reportData.planData" :isNewCompany="isNewCompany" 
        :admin_data="reportData.adminData" @refreshList="forceUpdate" @toggleCompanyPopup="toggleCompanyPopup">
    </editCompany>
</template>

<script>
import api from '../api/api.js';
import logDetail from './pop-up/logDetail.vue';
import editCompany from './pop-up/editCompany.vue';

export default {
    name: 'AllPlan',
    components: {
      logDetail,
      editCompany
    },
    data() {
      return {
        loginStatus: null,
        reportData: null,
        isLogin: false,

        isShowLogDetailPopup: false,
        logDetailData: [],
        logDetailComp: '',

        isShowCompanyPopup: false,
        isNewCompany: false,
        companyPlanData: [],

        isLoading: true,
      }
    },
    methods: {
      formatBytes(bytes) {
        if (bytes === 0) return '0 KB';
        const k = 1024;
        // const sizes = ['KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
        const sizes = ['KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        if (i > 3) {
          return parseFloat((bytes / Math.pow(k, 3)).toFixed(2)) + ' ' + sizes[3];
  
        } else {
          return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
        }
      },

      toggleLogDetailPopup(plan) {
        if (plan) {
          // console.log("debug " + plan.id);
          this.logDetailComp = plan.company_name;
          this.logDetailData = this.reportData.logData.filter(k => k.plan_id == plan.id);
          // console.log(this.reportData.logData);
        }
        this.isShowLogDetailPopup = !this.isShowLogDetailPopup;
      },

      toggleCompanyPopup(plan) {
        this.isNewCompany = false;
        if (plan) {
          this.companyPlanData = this.reportData.companyPlanData.filter(k => k.id == plan.id);
          this.companyPlanData.forEach(companyPlan => {
            companyPlan.search_period_limit = 0;
            this.reportData.searchPlanData.filter(j => (j.company_id == companyPlan.company_id)).forEach(searchPlan => {
              companyPlan.search_period_limit = searchPlan.search_period_limit;
            });

          });
        }
        this.isShowCompanyPopup = !this.isShowCompanyPopup;
      },

      newCompany(holderId) {
        this.companyPlanData = [];
        const newRec = [];
        newRec.id = 0;
        newRec.company_id = '';
        newRec.company_name = '';
        newRec.storage_plan_starttime = '';
        newRec.storage_plan_expirytime = '';
        newRec.storage_limit = 0;
        newRec.search_period_limit = 0;
        newRec.plan_id = 0;
        newRec.holder_id = holderId;
        newRec.lock_type = '';
        this.companyPlanData.push(newRec);

        this.isNewCompany = true;
        this.isShowCompanyPopup = true;
      },

      async forceUpdate() {
          this.isNewCompany = false;
          this.isLoading = true;
          const response = await api.getHolderReport();
          if (!response.errors) {
            if (response.data[0].attributes.extra.ricoh) {
              this.reportData = response.data[0].attributes.extra.ricoh.result
            } 
          }
          if (this.reportData == null || this.reportData.holderData.length == 0) {
            alert("No access right");
            this.$router.push({ path: '/home'});
          } else {
            let nowTime = new Date();

            this.reportData.holderData.forEach(holder => {
              holder.storage_used = 0;
              holder.search_used = 0;

              this.reportData.companyPlanData.filter(i => i.holder_id == holder.id).forEach(companyPlan => {
                holder.storage_used += companyPlan.storage_limit;

                // find valid year start date for current year searching status
                let startDate = new Date(companyPlan.search_plan_starttime);
                let checkDate = new Date(startDate);
                while (checkDate.setFullYear(checkDate.getFullYear() + 1) <= nowTime) {
                      startDate = new Date(checkDate);
                }
                // console.log(startDate.toLocaleDateString());

                companyPlan.reset_time = '';
                companyPlan.search_used = 0;
                companyPlan.year_used = 0;
                companyPlan.search_limit = 0;
                // if (companyPlan.search_plan_code == 1){
                //   companyPlan.search_limit = 1000;
                // }
                companyPlan.plan_name = '[Undefined]';
                this.reportData.planData.filter(k => (k.id == companyPlan.plan_id)).forEach(plan => {
                    companyPlan.plan_name = plan.plan_name;
                    if (companyPlan.search_plan_code == plan.search_plan_code){
                      // Default search limit
                      companyPlan.search_limit = plan.search_period_limit;
                    }
                })

                this.reportData.searchPlanData.filter(j => (j.company_id == companyPlan.company_id && new Date(j.period_starttime) >= startDate)).forEach(searchPlan => {
                    holder.search_used += searchPlan.search_period_used;
                    companyPlan.search_used = searchPlan.search_period_used;

                    // Actual Search Limit
                    companyPlan.year_used += searchPlan.search_period_used;
                    if (searchPlan.period_expirytime < companyPlan.search_plan_expirytime) {
                      companyPlan.search_limit = searchPlan.search_period_limit;
                      companyPlan.reset_time = searchPlan.period_expirytime;
                    } else {
                      companyPlan.search_limit = 0;
                    }
                })

              });
            });
          }
          this.isLoading = false;
      },

    },
    async mounted() {
      this.loginStatus = await api.loginStatusChecker();
      if (this.loginStatus == null) {
        this.$router.push({ path: '/login', query: { redirect: 'AllPlan' } })
      } else {
        // Check access right
        this.forceUpdate();
        this.isLogin = true;

      }
    },
}

</script>

<style>
table, th, td {
  border:1px solid black;
  text-align: left;
  padding: 2px;
}

.logo-col {
  width: 20%;
}

.company-total {
  text-align: left;
  padding: 2px;
}

.account-count {
  padding-right: 1rem;
}

#allplan {
  background:rgb(200, 224, 250);
}

</style>
